<template>
  <div class="invisible-overlay-disabled" :class="{ 'invisible-overlay-active': !show }">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    show: boolean;
  }>(),
  {
    show: false,
  }
);
</script>

<style lang="scss" scoped>
.invisible-overlay-disabled {
  opacity: 1;
  visibility: visible;
  transition:
    opacity 0.2s,
    visibility 0.2s;
}

.invisible-overlay-active {
  opacity: 0;
  visibility: hidden;
}
</style>
